import React, { createContext } from "react";

let StatsContext = createContext();

let initialState = {
  stats: {}
};

let reducer = (state, action) => {
  switch (action.type) {
    case "SET_STATS":
      return {
        ...state,
        stats: action.stats
      };

    default:
      return state;
  }
};

function ContextProvider(props) {
  let [statsState, statsDispatch] = React.useReducer(reducer, initialState);
  let value = { statsState, statsDispatch };

  return (
    <StatsContext.Provider value={value}>
      {props.children}
    </StatsContext.Provider>
  );
}

let ContextConsumer = StatsContext.Consumer;

export { StatsContext, ContextProvider, ContextConsumer };
